import React, { useState, useMemo, useEffect } from "react";
import { Row, Col, Card, Button } from "react-bootstrap";
import Leftmenubar from "../Components/Left_menubar";
import BackArrow from "../../../components/backArrow";
import RedoIcon from "@mui/icons-material/Redo";
import Nodata from "../../../components/Nodata";
import { getAsset, getShopVisitUrl } from "../../../helpers/helper";
import Loader from "../../../components/Loader";
import ShareModel from "../../../components/Sharemodel";
import ShareOption from "../../../components/Shareoption";
import OrderHistory from "../../../components/OrderHistory.js/OrderHistory";
import Suggestionreply from "../../../components/Suggest_reply";
import Reportreply from "../../../components/Report_reply";
import AddStatus from "../../../components/User-dashboard/Add_Status";
import { useHomeMadeShopsState } from "../../../hooks/useHomeMadeShopsState";
import noImagePlaceholder from "../../../assets/images/dummy/no_image_placeholder.png";
import { encodeId } from "../../../utils/idObfuscator";
import "../../../components/ShopItemsOwner/shopItems.css";

const HomeMadeShops = () => {
  const [activeShopTab, setActiveShopTab] = useState("created");
  const [selectedManagedShopId, setSelectedManagedShopId] = useState(null);
  const {
    location,
    navigate,
    homemadeShop,
    managedShops,
    pendingInvitations,
    isManagedLoading,
    isloading,
    showshare,
    show,
    setShow,
    userdash,
    setUserdash,
    userimg,
    isUserimgLoading,
    suggestdata,
    reportdata,
    servicedata,
    shareurl,
    setShareurl,
    handleCloseshare,
    handleClosemodal,
    handleShowshare,
  } = useHomeMadeShopsState();

  // Auto-switch to managed tab when an invitation is accepted (no page refresh, no polling, no websocket)
  useEffect(() => {
    const handleAutoSwitch = (event) => {
      setActiveShopTab("managed");
      setUserdash(0);
      if (event?.detail?.membershipId) {
        setSelectedManagedShopId(null);
      }
    };

    window.addEventListener("shop_invitation_accepted", handleAutoSwitch);

    const handleStorage = (e) => {
      if (e.key === "last_shop_membership_action") {
        try {
          const parsed = JSON.parse(e.newValue);
          if (parsed?.type === "INVITATION_ACCEPTED") {
            handleAutoSwitch({ detail: parsed });
          }
        } catch {}
      }
    };
    window.addEventListener("storage", handleStorage);

    let channel;
    if (typeof BroadcastChannel !== "undefined") {
      try {
        channel = new BroadcastChannel("shop_membership_channel");
        channel.onmessage = (msg) => {
          if (msg?.data?.type === "INVITATION_ACCEPTED") {
            handleAutoSwitch({ detail: msg.data });
          }
        };
      } catch (e) {}
    }

    return () => {
      window.removeEventListener("shop_invitation_accepted", handleAutoSwitch);
      window.removeEventListener("storage", handleStorage);
      if (channel) {
        try {
          channel.close();
        } catch (e) {}
      }
    };
  }, [setUserdash]);

  const filteredManagedShops = useMemo(() => {
    if (!managedShops || managedShops.length === 0) return [];
    if (!selectedManagedShopId) return managedShops;
    return managedShops.filter((m) => {
      const sId = m?.shopId?._id || m?.shopId;
      return (
        String(sId) === String(selectedManagedShopId) ||
        String(m?._id) === String(selectedManagedShopId)
      );
    });
  }, [managedShops, selectedManagedShopId]);

  const filteredPendingInvitations = useMemo(() => {
    if (!pendingInvitations || pendingInvitations.length === 0) return [];
    if (!selectedManagedShopId) return pendingInvitations;
    return pendingInvitations.filter((inv) => {
      const sId = inv?.shopId?._id || inv?.shopId;
      return (
        String(sId) === String(selectedManagedShopId) ||
        String(inv?._id) === String(selectedManagedShopId)
      );
    });
  }, [pendingInvitations, selectedManagedShopId]);

  return (
    <>
      <Row className="business-dashboard-shop-layout">
        <ShareOption
          showshare={showshare}
          handleCloseshare={handleCloseshare}
        />
        <ShareModel
          handleClosemodal={handleClosemodal}
          show={show}
          handleShowshare={handleShowshare}
          shareurl={shareurl}
        />
        <Col xs={12} lg={3} md={3}>
          <Leftmenubar
            userdash={userdash}
            setUserdash={setUserdash}
            userimg={userimg}
            isUserimgLoading={isUserimgLoading}
            activeShopTab={activeShopTab}
            setActiveShopTab={setActiveShopTab}
            managedShops={managedShops}
            pendingInvitations={pendingInvitations}
            selectedManagedShopId={selectedManagedShopId}
            setSelectedManagedShopId={setSelectedManagedShopId}
          />
        </Col>

        <Col
          xs={12}
          xl={8}
          lg={8}
          md={8}
          className="screenHeight b-radius border_2 ms-md-3 business-dashboard-content"
        >
          <Row
            className={`${
              location.pathname === "/user-dashboard" && (userdash || activeShopTab === "created")
                ? ""
                : "justify-content-sm-around justify-content-md-start"
            }`}
          >
            {location.pathname === "/user-dashboard" && (userdash || activeShopTab === "created") ? (
              <>
                {userdash === 2 && <OrderHistory />}
                {(!userdash || userdash === 1) && (
                  <Suggestionreply suggestdata={suggestdata} />
                )}
                {userdash === 4 && (
                  <Reportreply
                    reportdata={reportdata}
                    servicedata={servicedata}
                  />
                )}
                {userdash === 5 && <AddStatus />}
              </>
            ) : location.pathname !== "/user-dashboard" || activeShopTab === "created" ? (
              <>
                <Col xl="4" lg="3" md="3" sm="3" xs="6">
                  <div className="ms-4 ms-sm-2 ms-md-0 pt-4 pb-2">
                    <BackArrow back="/SellingSide" mystyle="d-none d-lg-block" />
                  </div>
                </Col>
                <Col xl="4" lg="5" md="6" sm="5" xs="6">
                  <div>
                    <h5 className="font-primary mt-4 res-manage-btn">
                      Manage Your Shops Here
                    </h5>
                  </div>
                </Col>
                <Col
                  lg="4"
                  md="3"
                  sm="3"
                  xs="5"
                  className="text-center text-lg-end text-md-end text-sm-center"
                >
                  <div className="mt-4 ps-lg-4 ps-md-2 p-xs-2 pe-sm-2">
                    <Button
                      className=""
                      onClick={() => navigate("/Home-Made-Form")}
                    >
                      Create New
                    </Button>
                  </div>
                </Col>
              </>
            ) : (
              <>
                <Col xl="4" lg="3" md="3" sm="3" xs="6">
                  <div className="ms-4 ms-sm-2 ms-md-0 pt-4 pb-2">
                    <BackArrow back="/SellingSide" />
                  </div>
                </Col>
                <Col xl="8" lg="9" md="9" sm="9" xs="6">
                  <div>
                    <h5 className="font-primary mt-4 res-manage-btn">
                      {selectedManagedShopId &&
                      filteredManagedShops[0]?.shopId?.shopname
                        ? filteredManagedShops[0].shopId.shopname
                        : "Managed Shops"}
                    </h5>
                  </div>
                </Col>
              </>
            )}
          </Row>
          {location.pathname === "/user-dashboard" && (userdash || activeShopTab === "created") ? (
            ""
          ) : isloading ? (
            <Loader heightsetting="loaderHeight" />
          ) : (
            <Row className="scroll-shops-business noscroll justify-content-center justify-content-sm-around justify-content-md-start">
              {location.pathname !== "/user-dashboard" || activeShopTab === "created" ? (
                homemadeShop && homemadeShop.length > 0 ? (
                  homemadeShop.map((e) => (
                    <Col
                      lg="4"
                      xl="3"
                      md="6"
                      sm="5"
                      xs="11"
                      className="mt-1"
                      key={e._id}
                    >
                      <Card className="ShopsCards_business">
                        <div className="fix-img">
                          <img
                            className="c_img"
                            src={
                              e?.image && e?.image !== "N/A"
                                ? getAsset(e?.image)
                                : noImagePlaceholder
                            }
                            alt=""
                            crossOrigin="anonymous"
                            onError={(ev) => {
                              ev.currentTarget.onerror = null;
                              ev.currentTarget.src = noImagePlaceholder;
                            }}
                          />
                        </div>

                        <Card.Body className="p-2">
                          <Card.Title className="font-sm-15 mb-0 pb-1">
                            <div className="d-flex justify-content-between">
                              {e?.shopname.length >= 12
                                ? e?.shopname.substring(0, 12) + `...`
                                : e?.shopname}

                              <button
                                className="text-white bg-blue share_font"
                                onClick={() => {
                                  setShareurl(e?.shopUrl);
                                  setShow(1);
                                }}
                              >
                                Share <RedoIcon className="share_icon_f" />
                              </button>
                            </div>
                          </Card.Title>
                          <Card.Text className="font-sm font-primary mb-2">
                            {e?.shopaddress.length >= 12
                              ? e?.shopaddress.substring(0, 12) + `...`
                              : e?.shopaddress}
                          </Card.Text>
                          <button
                            className="viewshop w-100 text-white bg-blue"
                            onClick={() => {
                              const obfuscatedId = encodeId(e._id);
                              localStorage.setItem("shopid", obfuscatedId);
                              navigate(`/rawmaterial-homemade/${obfuscatedId}`);
                            }}
                          >
                            Manage Your Shop
                          </button>
                        </Card.Body>
                      </Card>
                    </Col>
                  ))
                ) : (
                  <div>
                    <Nodata />
                  </div>
                )
              ) : isManagedLoading ? (
                <Loader heightsetting="loaderHeight" />
              ) : (filteredManagedShops && filteredManagedShops.length > 0) ||
                (filteredPendingInvitations &&
                  filteredPendingInvitations.length > 0) ? (
                <>
                  {filteredManagedShops.map((m) => {
                    const e = m.shopId;
                    if (!e) return null;
                    const obfuscatedId = encodeId(e._id);
                    return (
                      <Col
                        lg="4"
                        xl="3"
                        md="6"
                        sm="5"
                        xs="11"
                        className="mt-1"
                        key={m._id}
                      >
                        <Card className="ShopsCards_business">
                          <div className="fix-img">
                            <img
                              className="c_img"
                              src={
                                e?.image && e?.image !== "N/A"
                                  ? getAsset(e?.image)
                                  : noImagePlaceholder
                              }
                              alt=""
                              crossOrigin="anonymous"
                              onError={(ev) => {
                                ev.currentTarget.onerror = null;
                                ev.currentTarget.src = noImagePlaceholder;
                              }}
                            />
                          </div>

                          <Card.Body className="p-2">
                            <Card.Title className="font-sm-15 mb-0 pb-1">
                              <div className="d-flex justify-content-between align-items-center">
                                <span>
                                  {e?.shopname?.length >= 15
                                    ? e?.shopname.substring(0, 15) + `...`
                                    : e?.shopname || "Managed Shop"}
                                </span>
                                <span
                                  className="badge bg-primary text-white"
                                  style={{
                                    fontSize: "11px",
                                    padding: "3px 6px",
                                    borderRadius: "4px",
                                  }}
                                >
                                  {m.role === "admin" ? "Admin" : "Member"}
                                </span>
                              </div>
                            </Card.Title>
                            <Card.Text className="font-sm font-primary mb-2">
                              {e?.shopaddress?.length >= 12
                                ? e?.shopaddress.substring(0, 12) + `...`
                                : e?.shopaddress || "Shop Member"}
                            </Card.Text>
                            <button
                              className="viewshop w-100 text-white bg-blue"
                              onClick={() => {
                                const visitUrl = getShopVisitUrl(e);
                                const cleanShopId = e?._id || obfuscatedId;
                                localStorage.setItem("shopid", cleanShopId);
                                navigate(visitUrl);
                              }}
                            >
                              Manage Your Shop
                            </button>
                          </Card.Body>
                        </Card>
                      </Col>
                    );
                  })}

                  {filteredPendingInvitations.map((inv) => {
                    const e = inv.shopId;
                    const token = inv.shareToken || "";
                    const invitePath = `/shop-access-invitation/${inv._id}?token=${token}`;
                    return (
                      <Col
                        lg="4"
                        xl="3"
                        md="6"
                        sm="5"
                        xs="11"
                        className="mt-1"
                        key={inv._id}
                      >
                        <Card className="ShopsCards_business border border-warning">
                          <div className="fix-img">
                            <img
                              className="c_img"
                              src={
                                e?.image && e?.image !== "N/A"
                                  ? getAsset(e?.image)
                                  : noImagePlaceholder
                              }
                              alt=""
                              crossOrigin="anonymous"
                              onError={(ev) => {
                                ev.currentTarget.onerror = null;
                                ev.currentTarget.src = noImagePlaceholder;
                              }}
                            />
                          </div>

                          <Card.Body className="p-2">
                            <Card.Title className="font-sm-15 mb-0 pb-1">
                              <div className="d-flex justify-content-between align-items-center">
                                <span>
                                  {e?.shopname?.length >= 12
                                    ? e?.shopname.substring(0, 12) + `...`
                                    : e?.shopname || "Shop Invitation"}
                                </span>
                                <span
                                  className="badge bg-warning text-dark"
                                  style={{
                                    fontSize: "11px",
                                    padding: "3px 6px",
                                    borderRadius: "4px",
                                  }}
                                >
                                  Pending
                                </span>
                              </div>
                            </Card.Title>
                            <Card.Text className="font-sm font-primary mb-2">
                              Invited as{" "}
                              {inv.role === "admin" ? "Admin" : "Member"}
                            </Card.Text>
                            <button
                              className="viewshop w-100 text-white bg-success border-0"
                              onClick={() => {
                                navigate(invitePath);
                              }}
                            >
                              Accept Invite
                            </button>
                          </Card.Body>
                        </Card>
                      </Col>
                    );
                  })}
                </>
              ) : (
                <div>
                  <Nodata />
                </div>
              )}
            </Row>
          )}
        </Col>
      </Row>
    </>
  );
};

export default HomeMadeShops;
